import React from 'react';
import {
  WheelPicker as BaseWheelPicker,
  WheelPickerOption,
} from '@ncdai/react-wheel-picker';
import '@ncdai/react-wheel-picker/dist/style.css';
import styles from './wheel-picker.module.scss';

interface WheelPickerProps {
  options: string[];
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export const WheelPicker: React.FC<WheelPickerProps> = ({
  options,
  value,
  onValueChange,
  className,
}) => {
  const mappedOptions = React.useMemo<WheelPickerOption<string>[]>(() => {
    return options.map(opt => ({ value: opt, label: opt }));
  }, [options]);

  return (
    <div className={`${styles.pickerContainer} ${className || ''}`}>
      <BaseWheelPicker
        options={mappedOptions}
        value={value}
        onValueChange={onValueChange}
        classNames={{
          optionItem: styles.optionItem,
          highlightWrapper: styles.highlightWrapper,
          highlightItem: styles.highlightItem,
        }}
      />
    </div>
  );
};
